export type SkillCategory = "new" | "struggling" | "learning" | "review";

export type CategoryDisplayInfo = {
  label: string;
  labelShort: string;
  emoji: string;
  color: string;
  bgColor: string;
  borderColor: string;
  description: string;
};

export const CATEGORY_DISPLAY: Record<SkillCategory, CategoryDisplayInfo> = {
  new: {
    label: "Naujas",
    labelShort: "Nauja",
    emoji: "\u{1F195}",
    color: "text-cyan-700 dark:text-cyan-300",
    bgColor: "bg-cyan-50 dark:bg-cyan-950/30",
    borderColor: "border-cyan-200 dark:border-cyan-800",
    description: "Nauja tema - mokysim\u0117s kartu!",
  },
  struggling: {
    label: "Stiprinti",
    labelShort: "Stiprinti",
    emoji: "\u{1F4AA}",
    color: "text-amber-700 dark:text-amber-300",
    bgColor: "bg-amber-50 dark:bg-amber-950/30",
    borderColor: "border-amber-200 dark:border-amber-800",
    description: "Reikia daugiau praktikos",
  },
  learning: {
    label: "Mokytis",
    labelShort: "Mokytis",
    emoji: "\u{1F4DA}",
    color: "text-purple-700 dark:text-purple-300",
    bgColor: "bg-purple-50 dark:bg-purple-950/30",
    borderColor: "border-purple-200 dark:border-purple-800",
    description: "Progresuojame puikiai!",
  },
  review: {
    label: "Kartoti",
    labelShort: "Kartoti",
    emoji: "\u{1F504}",
    color: "text-green-700 dark:text-green-300",
    bgColor: "bg-green-50 dark:bg-green-950/30",
    borderColor: "border-green-200 dark:border-green-800",
    description: "\u012Etvirtinti \u017einias",
  },
};

export function getEncouragingMessage(
  category: SkillCategory,
  isSuccess: boolean
): string {
  const messages: Record<SkillCategory, { success: string; struggle: string }> =
    {
      new: {
        success: "Puiku! Naujas \u012fg\u016bdis \u012fsisavinamas!",
        struggle: "Nesijaudink, tai nauja tema. Pakartosime!",
      },
      struggling: {
        success: "Progresas! Tu tampi geresnis!",
        struggle: "Dar \u0161iek tiek praktikos ir pavyks!",
      },
      learning: {
        success: "Gerai sekasi!",
        struggle: "Beveik ten! T\u0119sk toliau.",
      },
      review: {
        success: "Atmintis veikia puikiai!",
        struggle: "Gal reikia daugiau kartojimo.",
      },
    };

  return isSuccess ? messages[category].success : messages[category].struggle;
}
